<template>
  <div class="collections-with-image">
    <div class="collection-row flex align-center justify-between" v-for="(viewComponent, index) of collectionsCopy">
      <collection-image-editor
        :view-component="viewComponent"
        :disabled="loading"
        :remove-image="() => removeImage(viewComponent)"
        :assign-image-url="(imageUrl) => assignNewImageUrl(viewComponent, imageUrl)"
      />

      <div class="flex align-end justify-between flex-grow-1">
        <div class="collection-title-wrapper">
          <text-field
            v-model="viewComponent.info.text"
            no-spacing
            :disabled="loading"
            width="full"
            :label="`Image Title ${getNumberByIndex(index)}`"
          />
        </div>

        <div class="collection-type-selector-wrapper">
          <dropdown
            :dropdown-items="collectionsTypes"
            :selected-name="getSelectedCollectionTypeName(viewComponent)"
            :disabled="loading"
            placeholder="Collection type"
            label="Collection Type"
            :on-select="(item) => handleCollectionTypeSelect(item, index)"
            :indicator-absolute="true"
          />
        </div>

        <template>
          <div v-if="viewComponent.info.collection_type === 'link'" class="collection-link-wrapper">
            <text-field
              v-model="viewComponent.info.link"
              no-spacing
              :disabled="loading"
              placeholder="Link"
              label="Link"
              width="full"
            ></text-field>
          </div>

          <div v-else class="collection-selector-wrapper">
            <collection-selector
              :algoliaCollections="algoliaCollections"
              :disabled="loading"
              :selected-name="getSelectedCollectionName(viewComponent)"
              :on-select="(item) => handleCollectionSelect(item, viewComponent)"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
.collections-with-image {
  margin-top: 48px;
  .collection-row {
    margin-bottom: 24px;

    .collection-title-wrapper {
      margin-right: 24px;
      width: 35%;
    }

    .collection-type-selector-wrapper {
      width: 30%;
      margin-right: 24px;
    }

    .collection-selector-wrapper,
    .collection-link-wrapper {
      width: 35%;
    }
  }
}
</style>

<script>
import { collectionListEditorBase } from "@/views/dashboard/contentManagment/navCollectionEditorPage/collectionListEditorBase";
import CollectionImageEditor from "@/views/dashboard/contentManagment/navCollectionEditorPage/collectionImageEditor";

export default {
  components: { CollectionImageEditor },
  mixins: [collectionListEditorBase],
  data: function () {
    return {
      collectionsCopy: [...this.extendViewComponentWithCollectionTypeField()],
      collectionsTypes: [
        { name: "Link", value: "link" },
        { name: "Collection", value: "collection" },
      ],
      selectedCollectionType: { name: "Link", value: "link" },
    };
  },
  methods: {
    extendViewComponentWithCollectionTypeField,
    handleCollectionTypeSelect,
    getSelectedCollectionTypeName,
    removeImage,
    assignNewImageUrl,
  },
};

function extendViewComponentWithCollectionTypeField() {
  return this.collections?.map((collection) => {
    return {
      ...collection,
      info: {
        ...collection.info,
        collection_type: collection.info.link ? "link" : "collection",
      },
    };
  });
}

function handleCollectionTypeSelect(item, index) {
  this.collectionsCopy[index].info.collection_type = item.value;
  if (item.value === "collection") {
    this.collectionsCopy[index].info.link = "";
  } else {
    this.collectionsCopy[index].entity_id = null;
  }
}

function getSelectedCollectionTypeName(viewComponent) {
  return this.collectionsTypes?.find((item) => item.value === viewComponent.info?.collection_type)?.name;
}

function removeImage(viewComponent) {
  const index = this.findCollectionItemIndex(viewComponent);
  this.collectionsCopy[index].info.image_url = "";
}

function assignNewImageUrl(viewComponent, imageUrl) {
  const index = this.findCollectionItemIndex(viewComponent);
  this.collectionsCopy[index].info.image_url = imageUrl;
}
</script>
